import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Forms from "../../../Componets/Form";
import toast from "react-hot-toast";
import Header from "../../../Componets/Header";
import forms from "../../../Data/Forms/SalesMan/forms";
import headers from "../../../Data/Forms/SalesMan/headers";
import Loadercomponent from "../../../Componets/Loader";
import {
  create_salesman,
  get_salesman,
  update_salesman,
} from "../../../Controllers/SalesMan";

const SalesManForm = ({ isModal = false, onClose }) => {
  let { id } = useParams();

  let navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [values, setValues] = useState(forms);
  const [header, setHeader] = useState(headers);

  const formdata = async (data) => {
    if (data?.status) {
      setButtonLoader(true);

      const salesmans = id
        ? await update_salesman({ id: id, ...data?.data })
        : await create_salesman(data?.data);

      if (salesmans?.status) {
        // if (id) {
        if (isModal) {
          onClose && onClose();
        } else {
          navigate(-1);
        }
        // }
        toast?.success(salesmans?.message);
        setButtonLoader(false);
      } else {
        setButtonLoader(false);
        if (salesmans?.status_code == 403) {
          window.location.href = "/unauthorized";
        } else {
          toast?.error(salesmans?.message);
        }
      }
    }
  };

  const handleData = (salesmans) => {
    let name = salesmans?.name ? salesmans?.name : "";
    let code = salesmans?.code ? salesmans?.code : "";
    let email = salesmans?.email ? salesmans?.email : "";
    let phone = salesmans?.phone ? salesmans?.phone : "";
    let status = salesmans?.status ? salesmans?.status : 0;

    forms[0].options[0].form.value = name;
    forms[0].options[1].form.value = code;

    forms[1].options[0].form.value = email;
    forms[1].options[1].form.value = phone;

    forms[2].options[0].form.value = status;

    setLoader(false);
    setValues([...values]);
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);

      const data = {
        id: id,
      };

      const salesmans = await get_salesman(data);

      console.log("salesmans", salesmans);

      if (salesmans?.status) {
        handleData(salesmans?.data);
      } else {
        toast?.error(salesmans?.message);
      }
    } else {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [buttonLoader]);

  const content = (
    <Loadercomponent loader={loader}>
      <Forms
        form={values}
        setForm={setValues}
        formdata={formdata}
        buttonLoader={buttonLoader}
        isModal={isModal}
        onModalClose={onClose}
      />
    </Loadercomponent>
  );

  return isModal ? (
    content
  ) : (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      {content}
    </Header>
  );
};

export default SalesManForm;
